import { Search } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

const MenuFilters = ({
  search,
  onSearchChange,
  filtroCategoria,
  onFiltroCategoriaChange,
  filtroStato,
  onFiltroStatoChange,
  categorie,
}) => (
  <div className="flex flex-col sm:flex-row gap-3">
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
      <Input
        placeholder="Cerca prodotto..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
        data-testid="search-input"
      />
    </div>
    <Select value={filtroCategoria} onValueChange={onFiltroCategoriaChange}>
      <SelectTrigger className="w-full sm:w-48" data-testid="filtro-categoria">
        <SelectValue placeholder="Categoria" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="tutte">Tutte le categorie</SelectItem>
        {categorie.map((c) => (
          <SelectItem key={c.id} value={c.id}>
            {c.icona} {c.nome}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    <Select value={filtroStato} onValueChange={onFiltroStatoChange}>
      <SelectTrigger className="w-full sm:w-36" data-testid="filtro-stato">
        <SelectValue placeholder="Stato" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="tutti">Tutti</SelectItem>
        <SelectItem value="attivi">Attivi</SelectItem>
        <SelectItem value="inattivi">Inattivi</SelectItem>
      </SelectContent>
    </Select>
  </div>
);

export default MenuFilters;
